import { render } from "./imprint-view-component.vue?vue&type=template&id=4f6bd99e&scoped=true&ts=true"
import script from "./imprint-view-component.vue?vue&type=script&lang=ts"
export * from "./imprint-view-component.vue?vue&type=script&lang=ts"

import "./imprint-view-component.vue?vue&type=style&index=0&id=4f6bd99e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6bd99e"]])

export default __exports__